<template>
	<div class="c-sidebar__container">
		<div
			:class="[
				'c-sidebar',
				{ active: showSidebar },
				{ 'mobile-active': showMobileSidebar },
			]"
		>
			<Popup ref="popup" :menu="$refs.menu"></Popup>
			<div class="c-sidebar__header">
				<span @click="close">
					<svg
						width="24"
						height="24"
						viewBox="0 0 24 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							fill-rule="evenodd"
							clip-rule="evenodd"
							d="M4 4C2.89543 4 2 4.89543 2 6V18C2 19.1046 2.89543 20 4 20H20C21.1046 20 22 19.1046 22 18V6C22 4.89543 21.1046 4 20 4H4ZM4 6L10 6V18H4V6Z"
							fill="currentColor"
						/>
					</svg>
				</span>
				<h1 class="workspace-logo" href="">
					<img src="/logo-text-light.svg" />
				</h1>
				<span @click="toggleMenu" :class="[{ active: menuActive }]">
					<svg
						ref="menu"
						width="24"
						height="24"
						viewBox="0 0 24 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M16 11.9999L8 12.0001M12 16V8.00012M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
							stroke="currentColor"
							stroke-width="2"
							stroke-linecap="round"
							stroke-linejoin="round"
						/>
					</svg>
				</span>
			</div>
			<div class="c-sidebar__buttons">
				<router-link class="big-button" to="/">
					<svg
						width="24"
						height="24"
						viewBox="0 0 24 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M9.5 16.5V20H5C4.44772 20 4 19.5523 4 19V9.53986C4 9.20293 4.16966 8.88866 4.45134 8.70381L11.4513 4.11006C11.7845 3.89146 12.2155 3.89146 12.5487 4.11006L19.5487 8.70381C19.8303 8.88866 20 9.20293 20 9.53986V19C20 19.5523 19.5523 20 19 20H14.5V16.5C14.5 15.1193 13.3807 14 12 14C10.6193 14 9.5 15.1193 9.5 16.5Z"
							stroke="currentColor"
							stroke-width="1.5"
							stroke-linejoin="round"
						/>
					</svg>

					<article>
						<span> Library </span>
						<p>All your ads in one place</p>
					</article>
				</router-link>
				<router-link class="big-button" to="/brands">
					<svg
						width="24"
						height="24"
						viewBox="0 0 24 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M16 7.19956C14.9554 6.44633 13.657 6 12.25 6C8.79822 6 6 8.68629 6 12C6 15.3137 8.79822 18 12.25 18C13.657 18 14.9554 17.5537 16 16.8004M17.8667 20.0007C16.2093 21.2561 14.1491 22 11.9167 22C6.43984 22 2 17.5228 2 12C2 6.47715 6.43984 2 11.9167 2C14.1491 2 16.2093 2.74389 17.8667 3.99927C18.2444 4.25877 18.5 4.5 18.5 5M14 10L20.5 3.5M14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12Z"
							stroke="currentColor"
							stroke-linecap="round"
							stroke-width="1.5"
						/>
					</svg>
					<article>
						<span> Brand Tracker </span>
						<p>Spy your competition</p>
					</article>
				</router-link>
				<router-link class="big-button" to="/multiplayer">
					<svg
						xmlns="http://www.w3.org/2000/svg"
						xmlns:xlink="http://www.w3.org/1999/xlink"
						aria-hidden="true"
						role="img"
						x="256"
						y="256"
						class="iconify iconify--ion"
						viewBox="0 0 512 512"
					>
						<path
							stroke-width="1.5"
							fill="currentColor"
							d="M483.13 245.38C461.92 149.49 430 98.31 382.65 84.33A107.13 107.13 0 0 0 352 80c-13.71 0-25.65 3.34-38.28 6.88C298.5 91.15 281.21 96 256 96s-42.51-4.84-57.76-9.11C185.6 83.34 173.67 80 160 80a115.74 115.74 0 0 0-31.73 4.32c-47.1 13.92-79 65.08-100.52 161C4.61 348.54 16 413.71 59.69 428.83a56.62 56.62 0 0 0 18.64 3.22c29.93 0 53.93-24.93 70.33-45.34c18.53-23.1 40.22-34.82 107.34-34.82c59.95 0 84.76 8.13 106.19 34.82c13.47 16.78 26.2 28.52 38.9 35.91c16.89 9.82 33.77 12 50.16 6.37c25.82-8.81 40.62-32.1 44-69.24c2.57-28.48-1.39-65.89-12.12-114.37ZM208 240h-32v32a16 16 0 0 1-32 0v-32h-32a16 16 0 0 1 0-32h32v-32a16 16 0 0 1 32 0v32h32a16 16 0 0 1 0 32Zm84 4a20 20 0 1 1 20-20a20 20 0 0 1-20 20Zm44 44a20 20 0 1 1 20-19.95A20 20 0 0 1 336 288Zm0-88a20 20 0 1 1 20-20a20 20 0 0 1-20 20Zm44 44a20 20 0 1 1 20-20a20 20 0 0 1-20 20Z"
						></path>
					</svg>
					<article>
						<span> Multiplayer </span>
						<p>Browse 1M+ ads</p>
					</article>
				</router-link>

				<router-link class="big-button" to="/generations">
					<svg
						width="24"
						height="24"
						viewBox="0 0 24 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							fill-rule="evenodd"
							clip-rule="evenodd"
							d="M10 11C10 9.89543 10.8954 9 12 9H20C21.1046 9 22 9.89543 22 11V19C22 20.1046 21.1046 21 20 21H12C10.8954 21 10 20.1046 10 19V11ZM15.4142 19H20V18.4142L18 16.4142L15.4142 19ZM20 15.5858L19.4142 15C18.6332 14.219 17.3668 14.219 16.5858 15L12.5858 19H12V11H20V15.5858Z"
							fill="currentColor"
						/>
						<path
							d="M15.5 13.25C15.5 13.9404 14.9404 14.5 14.25 14.5C13.5596 14.5 13 13.9404 13 13.25C13 12.5596 13.5596 12 14.25 12C14.9404 12 15.5 12.5596 15.5 13.25Z"
							fill="currentColor"
						/>
						<path
							fill-rule="evenodd"
							clip-rule="evenodd"
							d="M1 5C1 3.89543 1.89543 3 3 3H9C10.1046 3 11 3.89543 11 5C11 5.55228 10.5523 6 10 6C9.44772 6 9 5.55228 9 5H7V12C7.55228 12 8 12.4477 8 13C8 13.5523 7.55228 14 7 14H5C4.44772 14 4 13.5523 4 13C4 12.4477 4.44772 12 5 12V5H3C3 5.55228 2.55228 6 2 6C1.44772 6 1 5.55228 1 5Z"
							fill="currentColor"
						/>
						<path
							d="M20.7552 2.15769C20.6501 1.94744 20.35 1.94744 20.2449 2.15769C19.5905 3.46646 19.4665 3.5905 18.1577 4.24488C17.9474 4.35001 17.9474 4.65005 18.1577 4.75518C19.4665 5.40956 19.5905 5.5336 20.2449 6.84237C20.35 7.05262 20.6501 7.05262 20.7552 6.84237C21.4096 5.5336 21.5336 5.40956 22.8424 4.75518C23.0526 4.65005 23.0526 4.35001 22.8424 4.24488C21.5336 3.5905 21.4096 3.46646 20.7552 2.15769Z"
							fill="currentColor"
						/>
						<path
							d="M15.2645 4.16345C15.1555 3.94552 14.8445 3.94552 14.7355 4.16345C14.2499 5.13469 14.1347 5.24991 13.1635 5.73553C12.9455 5.8445 12.9455 6.1555 13.1635 6.26447C14.1347 6.75009 14.2499 6.86532 14.7355 7.83655C14.8445 8.05448 15.1555 8.05448 15.2645 7.83655C15.7501 6.86532 15.8653 6.75009 16.8365 6.26447C17.0545 6.1555 17.0545 5.8445 16.8365 5.73553C15.8653 5.24991 15.7501 5.13468 15.2645 4.16345Z"
							fill="currentColor"
						/>
						<path
							d="M4.75514 16.1577C4.65002 15.9474 4.34998 15.9474 4.24486 16.1577C3.59048 17.4664 3.46644 17.5905 2.15769 18.2449C1.94744 18.35 1.94744 18.65 2.15769 18.7551C3.46644 19.4095 3.59048 19.5336 4.24486 20.8423C4.34998 21.0526 4.65002 21.0526 4.75514 20.8423C5.40952 19.5336 5.53356 19.4095 6.84231 18.7551C7.05256 18.65 7.05256 18.35 6.84231 18.2449C5.53356 17.5905 5.40952 17.4664 4.75514 16.1577Z"
							fill="currentColor"
						/>
					</svg>

					<article>
						<span> AI Generations </span>
						<p>Saved AI generations</p>
					</article>
				</router-link>
				<router-link class="big-button" to="/mcp">
					<svg
						xmlns="http://www.w3.org/2000/svg"
						viewBox="0 0 24 24"
						fill="none"
					>
						<path
							d="M11.0533 2.79347C12.4449 1.40182 14.7017 1.40188 16.0933 2.79347L16.2193 2.92628C16.9519 3.73696 17.2448 4.80308 17.1002 5.81886C18.1172 5.67274 19.1848 5.96602 19.9966 6.69972L20.1294 6.82569L20.1714 6.86769L20.2974 7.0005C21.5615 8.3994 21.5197 10.5595 20.1714 11.9077L12.8785 19.2007C12.786 19.2935 12.7858 19.444 12.8785 19.5366L14.3755 21.0337C14.6538 21.312 14.6538 21.7632 14.3755 22.0415C14.0972 22.3196 13.646 22.3198 13.3677 22.0415L11.8707 20.5444C11.2213 19.8951 11.2215 18.8423 11.8707 18.1929L19.1627 10.8999C19.9456 10.1171 19.9952 8.87744 19.3101 8.03761L19.1627 7.8755L19.1207 7.83351C18.2856 6.99932 16.932 6.99885 16.0972 7.83351L10.0914 13.8394C10.085 13.8458 10.0765 13.8499 10.0699 13.856L10.0035 13.9234C9.72519 14.2014 9.27393 14.2014 8.99566 13.9234C8.71756 13.6451 8.71763 13.1939 8.99566 12.9155L15.0855 6.82569C15.9205 5.99069 15.9205 4.63629 15.0855 3.80128C14.2505 2.96644 12.8961 2.96629 12.0611 3.80128L3.99761 11.8648C3.71926 12.143 3.2681 12.1431 2.9898 11.8648C2.71179 11.5864 2.71167 11.1352 2.9898 10.8569L11.0533 2.79347Z"
							fill="currentColor"
						/>
						<path
							d="M13.0777 4.80909C13.356 4.53092 13.8072 4.53098 14.0855 4.80909C14.3638 5.0874 14.3637 5.53856 14.0855 5.81691L8.12164 11.7808C7.28687 12.6156 7.28712 13.9691 8.12164 14.8042C8.95667 15.6392 10.311 15.6392 11.146 14.8042L17.1099 8.84132C17.3882 8.56315 17.8394 8.56321 18.1177 8.84132C18.3956 9.11965 18.3958 9.57091 18.1177 9.84913L12.1539 15.813C10.7622 17.2045 8.50553 17.2044 7.11382 15.813C5.72238 14.4213 5.72225 12.1646 7.11382 10.773L13.0777 4.80909Z"
							fill="currentColor"
						/>
					</svg>

					<article>
						<span> MCP </span>
						<p>Connect Swipekit to Claude</p>
					</article>
				</router-link>
				<span class="c-sidebar__item__divider"></span>
				<!-- <a
					class="c-sidebar__item big-button"
					@click.prevent="uploadAd"
					href="#"
				>
					<svg
						width="24"
						height="24"
						viewBox="0 0 24 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M20 12.75V18C20 19.1046 19.1046 20 18 20H6C4.89543 20 4 19.1046 4 18V12.75M12 4V15.25M12 4L16.5 8.5M12 4L7.5 8.5"
							stroke="currentColor"
							stroke-width="1.5"
							stroke-linecap="round"
							stroke-linejoin="round"
						/>
					</svg>
					<article>
						<span> Upload Ads </span>
					</article>
				</a>
				<a
					class="c-sidebar__item big-button"
					@click.prevent="addBoard"
					href="#"
				>
					<svg
						width="24"
						height="24"
						viewBox="0 0 24 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M5 6H19M7 3H17M5 21H19C20.1046 21 21 20.1046 21 19V11C21 9.89543 20.1046 9 19 9H5C3.89543 9 3 9.89543 3 11V19C3 20.1046 3.89543 21 5 21Z"
							stroke="currentColor"
							stroke-linecap="round"
							stroke-width="1.5"
						/>
					</svg>

					<article>
						<span> Create Board </span>
					</article>
				</a> -->
			</div>

			<div class="c-sidebar__body">
				<FolderSelect :trigger="showSidebar"></FolderSelect>
			</div>

			<div class="c-sidebar__footer">
				<div class="c-sidebar__buttons">
					<a href="https://swipekit.app/help">
						<svg
							width="24"
							height="24"
							viewBox="0 0 24 24"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M18.5 5.5L14.8659 9.13411M9.1289 14.8711L5.5 18.5M5.5 5.5L9.1289 9.1289M14.8659 14.8659L18.5 18.5M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12ZM16 12C16 14.2091 14.2091 16 12 16C9.79086 16 8 14.2091 8 12C8 9.79086 9.79086 8 12 8C14.2091 8 16 9.79086 16 12Z"
								stroke="currentColor"
								stroke-width="2"
							/>
						</svg>

						<span> Helpdesk </span>
					</a>
					<a @click.prevent="openSupport" href="#">
						<svg
							width="24"
							height="24"
							viewBox="0 0 24 24"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M16.9998 14H20.002C20.5542 14 21.002 13.5523 21.002 13V5C21.002 4.44772 20.5542 4 20.002 4H8.00195C7.44967 4 7.00195 4.44772 7.00195 5V8M16.002 8H4.00195C3.44967 8 3.00195 8.44772 3.00195 9V17C3.00195 17.5523 3.44967 18 4.00195 18H6.00195V20.5L10.502 18H16.002C16.5542 18 17.002 17.5523 17.002 17V9C17.002 8.44772 16.5542 8 16.002 8Z"
								stroke="currentColor"
								stroke-width="2"
								stroke-linecap="round"
								stroke-linejoin="round"
							/>
						</svg>

						<span> Support </span>
					</a>
					<span class="c-sidebar__item__divider"></span>
					<a
						v-if="!extensionState"
						target="_blank"
						href="https://chromewebstore.google.com/detail/ad-library-downloader/gojmmkhaiojimnnjhhilmhjmhdbdagod"
						class="big-button"
					>
						<img src="/brands/chrome-webstore.svg" />
						<article>
							<span> Install Chrome extension </span>
						</article>
					</a>
					<router-link
						to="/profile"
						href="https://swipekit.app/help"
						class="big-button"
					>
						<img
							v-if="user && user.avatar"
							:title="`${user.name}'s profile`"
							:src="`${assetUrl}/${user.avatar.name}`"
						/>
						<article>
							<span v-if="user"> {{ user.name }} </span>
							<p v-if="workspace">
								{{ workspace.name }}
							</p>
						</article>
					</router-link>
					<BarCredits></BarCredits>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import FormBulkEdit from '@swipekit/components/form/form-bulk-edit';
import InputButtonChoice from '@swipekit/components/form/input-button-choice';
import FolderSelect from '@swipekit/components/folder-select';
import Popup from './popup';
import BarCredits from './bar-credits.vue';

export default {
	components: {
		FormBulkEdit,
		InputButtonChoice,
		FolderSelect,
		Popup,
		BarCredits,
	},

	computed: {
		extensionState: function () {
			return this.$store.getters['extensionState'];
		},
		menuActive: function () {
			if (this.$refs.popup) {
				return this.$refs.popup.showMenu;
			}
		},
		assetUrl: function () {
			return this.$store.getters['config/assetUrl'];
		},
		user: function () {
			return this.$store.getters['users/user'];
		},
		workspace: function () {
			return this.$store.getters['workspaces/all'];
		},
		showSidebar: function () {
			return this.$store.getters['app/showSidebar'];
		},
		showMobileSidebar: function () {
			return this.$store.getters['app/showMobileSidebar'];
		},
		selection: function () {
			return this.$store.getters['ads/selection'];
		},
		countString: function () {
			let selection = this.selection;

			let str = `${selection.length} ads`;

			if (selection.length === 1) {
				str = `${selection.length} ad`;
			}

			return str;
		},
		slug: function () {
			return this.$route.params.slug;
		},
		board: function () {
			if (!this.slug) {
				return;
			}
			return this.$store.getters['boards/boardBySlug'](this.slug);
		},
		workspace: function () {
			return this.$store.getters['workspaces/all'];
		},
	},

	methods: {
		toggleMenu: function () {
			this.$refs.popup.toggleMenu();
		},
		close: function () {
			this.$store.dispatch('app/toggleSidebar');
		},
		addBoard: function () {
			this.$store.dispatch('boards/setAdd', 1);
		},
		uploadAd: function () {
			this.$store.dispatch('ads/setAdd', 1);
		},
		openSupport: function () {
			let canUseCrisp = this.$store.getters['users/canUseCrisp'];

			if (canUseCrisp && window.$crisp) {
				$crisp.push(['do', 'chat:open']);
				return;
			}

			let subject = encodeURIComponent('Swipekit support, help needed');
			window.location.href = `mailto:shash@swipekit.app?subject=${subject}`;
		},

		handleClickOutside(e) {
			let str = `.c-sidebar > .c-popup`;
			let str2 = `.c-sidebar__header svg`;
			if (!e.target.closest(str)) {
				if (!e.target.closest(str2)) {
					this.$refs.popup.closeMenu();
				}
			}
		},
	},

	mounted: function () {
		document.addEventListener('mousedown', this.handleClickOutside);
	},

	beforeDestroy: function () {
		document.removeEventListener('mousedown', this.handleClickOutside);
	},
};
</script>

<style lang="scss">
.c-sidebar {
	--color-font: #ededed;
	--sidebar-gap: 64px;
	position: fixed;
	top: 0;
	left: 0;
	width: 300px;
	height: 100%;
	z-index: 101;
	background-color: var(--color-bg-97); //hsla(var(--p), 12%, 8%, 0.95);
	backdrop-filter: blur(8px);

	box-shadow: 0px 2.2px 5.3px rgba(0, 0, 0, 0.065),
		0px 7.4px 17.9px rgba(0, 0, 0, 0.095), 0px 33px 80px rgba(0, 0, 0, 0.16);

	transition: all var(--transition-time) cubic-bezier(0.215, 0.61, 0.355, 1);

	transform: translateX(-4px);

	opacity: 0;
	pointer-events: none;
	display: grid;
	grid-template-rows: min-content min-content 1fr min-content;

	&.active {
		transform: translateX(0);
		opacity: 1;
		pointer-events: all;
	}

	.workspace-logo {
		display: flex;
		flex-grow: 1;
		align-items: center;
		font-size: 16px;
		margin: 0;
		color: var(--color-button-font);
		padding: 0.125rem var(--margin);
		padding-right: var(--margin-lg);
		user-select: none;
		font-weight: 600;

		border-radius: var(--border-radius);
		text-decoration: none !important;

		img {
			display: inline-block;
			height: 20px;
			margin-right: var(--margin-lg);
		}

		svg {
			margin-left: auto;
		}
	}

	&__header {
		padding: var(--margin-lg);
		padding-left: 14px;
		padding-bottom: 0;
		display: flex;
		align-items: center;

		> span {
			display: inline-block;
			width: 28px;
			height: 28px;
			position: relative;
			padding: 4px;
			margin-left: -4px;
			margin-right: 16px;
			border-radius: var(--border-radius);
			cursor: pointer;
			user-select: none;

			&:hover,
			&:active,
			&.active {
				background-color: rgba(255, 255, 255, 0.2);
			}

			> svg {
				display: block;
				color: #fff;
				width: 20px;
				height: 20px;
			}

			&:first-of-type {
				display: none;
			}

			&:last-of-type {
				margin-right: -4px;
				margin-left: 16px;

				&:after {
					right: auto;
					left: -8px;
				}
			}
		}
	}

	&__body {
		height: 100%;
		overflow-x: auto;

		&::-webkit-scrollbar {
			width: 6px;
		}

		&::-webkit-scrollbar-thumb {
			background: hsl(var(--p), 6%, 18%);
			border-radius: 0;
		}

		&::-webkit-scrollbar-thumb:hover {
			background: hsl(var(--p), 6%, 18%);
		}

		&::-webkit-scrollbar-track {
			background: transparent;
		}
	}

	&__buttons {
		padding: var(--margin-lg);
		padding-bottom: 0;

		> span {
			display: block;
			width: calc(100% - 2rem);
			margin: var(--margin) 0;
			height: 1px;
			background-color: rgba(255, 255, 255, 0.075);
		}

		a {
			width: 100%;
			position: relative;
			display: flex;
			align-items: center;
			padding: var(--margin);
			font-size: 14px;
			text-decoration: none !important;
			border-radius: 6px;
			color: rgba(255, 255, 255, 0.9);
			background-color: var(--color-bg-97);
			user-select: none;

			&:not(:last-child) {
				margin-bottom: 0.125rem;
			}

			svg {
				width: 16px;
				height: 16px;
				margin-right: 8px;
			}

			span {
				padding: 0;
			}

			&.router-link-exact-active {
				background-color: rgba(255, 255, 255, 0.1);
			}

			&:hover,
			&:active {
				background-color: rgba(255, 255, 255, 0.1);
				color: var(--color-font);
			}

			&.big-button {
				display: grid;
				padding-left: 8px;
				grid-template-columns: min-content 1fr;

				span {
					line-height: 1;
				}

				svg,
				img {
					min-width: 32px;
					width: 32px;
					height: 32px;
					padding: 4px;
					border: rgba(255, 255, 255, 0.1) solid 1px;
					background-color: rgba(255, 255, 255, 0.1);
					border-radius: 4px;
				}

				img {
					padding: 0;
					margin-right: 8px;
					object-fit: cover;
					object-position: center center;
				}

				p {
					font-size: var(--font-size-xs);
					margin: 0;
					opacity: 0.65;
					line-height: 1.3;
				}

				&:hover,
				&:active,
				&.router-link-exact-active {
					p {
						opacity: 1;
					}
				}
			}
		}
	}

	&__footer {
		position: relative;

		.c-sidebar__buttons {
			padding-bottom: var(--margin-lg);
		}

		&:before {
			content: '';
			position: absolute;
			top: -8px;
			left: 0;
			width: 100%;
			height: 8px;
			background: linear-gradient(
				0deg,
				hsla(var(--p), 4%, 12%, 1) 0%,
				hsla(var(--p), 4%, 12%, 0) 100%
			);
		}
	}

	@media (max-width: 768px) {
		right: var(--spacer);
		width: calc(100% - 12px);
		border-top-right-radius: var(--border-radius-lg);
		border-bottom-right-radius: var(--border-radius-lg);
		transform: translateX(0);
		opacity: 1;
		pointer-events: all;

		&.active {
			transform: translateX(-100%);
			opacity: 0;
			pointer-events: none;
		}

		&__header {
			> span {
				&:first-of-type {
					display: inline-block;
				}
			}
		}
	}
}
</style>
